export default {
    getList: {
        default: [{
            alert_id: "c2babb15763240f29a249dddfccee277",
            content: "FTP115 was unavailable",
            host: "FTP115",
            occure_at: "2018-12-04 01:08:07",
            severity: 4,
            site_id: 10,
            site_name: "玉环市第二人民医院",
            status: 2
        }, {
            alert_id: "6072270aebca41bc8f28b3e2c66989d5",
            content: "Status of BBU 'A' was abnormal on EMC VNX5600(DX)",
            host: "EMC VNX5600(DX)",
            occure_at: "2018-12-03 08:00:33",
            severity: 4,
            site_id: 47,
            site_name: "天台县人力资源和社会保障局",
            status: 2
        }, {
            alert_id: "c2babb15763240f29a249dddfccee277",
            content: "FTP115 was unavailable",
            host: "FTP115",
            occure_at: "2018-12-04 01:08:07",
            severity: 4,
            site_id: 10,
            site_name: "玉环市第二人民医院",
            status: 2
        }]
    }
}